import { createQueryKey } from '../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../query/types';
import { causesKeys } from './causes/keys';
import { studentFeesConsumerKeys } from './consumer/keys';
import { feesKeys } from './fees/keys';
import { groupsKeys } from './groups/keys';
import { studentFeesKeys } from './studentFees/keys';
import { studentRosterKeys } from './studentRoster/keys';
import { studentsKeys } from './students/keys';

/**
 * Query keys for ['student', scopeId, *]
 *
 * @param  scopeId is the scope in which we want to query the student api with
 */
const scopedIdKeys = (inheritedKeys: QueryKey, scopeId?: QueryKeyParam) => {
  const newKey = [...inheritedKeys, scopeId] as const;
  return createQueryKey({
    all: newKey,
    fees: feesKeys(newKey),
    groups: groupsKeys(newKey),
    students: studentsKeys(newKey),
    studentFees: studentFeesKeys(newKey),
    studentRoster: studentRosterKeys(newKey),
    consumer: studentFeesConsumerKeys(newKey),
    causes: causesKeys(newKey),
  });
};

const studentKeys = createQueryKey({
  all: ['student'] as const,
  id: <T extends QueryKeyParam>(id: T) => scopedIdKeys(['student'], id),
});

export { studentKeys };
